export default {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  user: null,
  users: [],
  usersOptions: [],
  student: null,
  students: []
}
